export default {
    props: {
        panesBackground: {
            type: String,
            default: undefined,
            kComposite: 'panes.background'
        }, 
        panesBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'panes.border.color'
        }, 
        panesBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'panes.border.dashType'
        }, 
        panesBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'panes.border.width'
        }, 
        panesClip: {
            type: Boolean,
            default: undefined,
            kComposite: 'panes.clip'
        }, 
        panesHeight: {
            type: Number,
            default: undefined,
            kComposite: 'panes.height'
        }, 
        panesMargin: {
            type: Number,
            default: undefined,
            kComposite: 'panes.margin'
        }, 
        panesMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'panes.margin.bottom'
        }, 
        panesMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'panes.margin.left'
        }, 
        panesMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'panes.margin.right'
        }, 
        panesMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'panes.margin.top'
        }, 
        panesName: {
            type: String,
            default: undefined,
            kComposite: 'panes.name'
        }, 
        panesPadding: {
            type: Number,
            default: undefined,
            kComposite: 'panes.padding'
        }, 
        panesPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'panes.padding.bottom'
        }, 
        panesPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'panes.padding.left'
        }, 
        panesPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'panes.padding.right'
        }, 
        panesPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'panes.padding.top'
        }, 
        panesTitle: {
            type: String,
            default: undefined,
            kComposite: 'panes.title'
        }, 
        panesTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'panes.title.background'
        }, 
        panesTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'panes.title.border.color'
        }, 
        panesTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'panes.title.border.dashType'
        }, 
        panesTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'panes.title.border.width'
        }, 
        panesTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'panes.title.color'
        }, 
        panesTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'panes.title.font'
        }, 
        panesTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'panes.title.margin'
        }, 
        panesTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'panes.title.margin.bottom'
        }, 
        panesTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'panes.title.margin.left'
        }, 
        panesTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'panes.title.margin.right'
        }, 
        panesTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'panes.title.margin.top'
        }, 
        panesTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'panes.title.position'
        }, 
        panesTitleText: {
            type: String,
            default: undefined,
            kComposite: 'panes.title.text'
        }, 
        panesTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'panes.title.visible'
        }, 
        panesTitleVisual: {
            type: Function,
            default: undefined,
            kComposite: 'panes.title.visual'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/Panes.js